import { InputText } from '@/components/_common';
import {
  ConfirmPurchaseModalFormValues,
  PurchaseItems,
} from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import { getTableScrollX } from '@/utils/table';
import { Col, Form, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import React from 'react';

const InputCstForNcm: React.FC = () => {
  const form = Form.useFormInstance<ConfirmPurchaseModalFormValues>();

  const columns: ColumnsType<PurchaseItems> = [
    {
      title: 'NCM',
      dataIndex: ['ncm', 'code'],
      key: 'ncm',
      render: (value) => value,
      width: 200,
    },
    {
      title: 'CST PIS',
      key: 'cstPis',
      render: (_, _row, index) => {
        return (
          <Form.Item noStyle name={[index, 'purchaseItemTaxes', 'cstPis']}>
            <InputText onlyNumber maxLength={2} />
          </Form.Item>
        );
      },
      width: 150,
    },
    {
      title: 'CST COFINS',
      key: 'cstCofins',
      render: (_, _row, index) => {
        return (
          <Form.Item noStyle name={[index, 'purchaseItemTaxes', 'cstCofins']}>
            <InputText onlyNumber maxLength={2} />
          </Form.Item>
        );
      },
      width: 150,
    },
    {
      title: 'CST IPI',
      key: 'cstIpi',
      render: (_, _row, index) => {
        return (
          <Form.Item noStyle name={[index, 'purchaseItemTaxes', 'cstIpi']}>
            <InputText onlyNumber maxLength={2} />
          </Form.Item>
        );
      },
      width: 150,
    },
  ];
  return (
    <>
      <Col lg={24}>
        <Typography.Title level={5}>
          Informe os CST's de entrada para os NCMs
        </Typography.Title>

        <Form.List name="itemsNcm" initialValue={[]}>
          {() => {
            const items = form.getFieldValue('itemsNcm') as PurchaseItems[];

            return (
              <Table
                columns={columns}
                dataSource={items}
                rowKey={(_row, index) => String(index)}
                scroll={{ x: getTableScrollX(columns) }}
                pagination={false}
              />
            );
          }}
        </Form.List>
      </Col>
    </>
  );
};

export default InputCstForNcm;
